import styled, { keyframes } from 'styled-components';

import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const RootSVG = styled.svg`
  color: var(--text-default);
`;

export const AxisLine = styled.line`
  stroke: var(--border-default);
`;

export const AxisText = styled.text`
  ${typographyV2.bodyXs};
  fill: var(--text-default);
`;

const slideIn = keyframes`
  from {
    transform: translateY(5%);
  }
  to {
    transform: translateY(0);
  }
`;

export const Circle = styled.circle`
  stroke: var(--surface-inverse);
  stroke-width: 1px;
  fill: var(--background-default);
`;

export const Rect = styled.rect<{ $hasProfit: boolean }>`
  fill: ${props =>
    props.$hasProfit ? 'var(--viz-bullish)' : 'var(--viz-bearish)'};
`;

export const Line = styled.path<{
  $hasProfit: boolean;
  strokeDasharray?: string;
  $strokeWidth?: number;
}>`
  stroke: ${props =>
    props.$hasProfit ? 'var(--viz-bullish)' : 'var(--viz-bearish)'};
  stroke-width: ${props => props.$strokeWidth ?? 2}px;
  fill: none;
  ${props =>
    props.strokeDasharray && `stroke-dasharray: ${props.strokeDasharray};`}
`;

export const AreaFill = styled.path<{
  $hasProfit: boolean;
  clipPath?: string;
  gradientId?: string;
}>`
  fill: ${props =>
    props.gradientId
      ? `url(#${props.gradientId})`
      : props.$hasProfit
      ? 'var(--viz-bullish)'
      : 'var(--viz-bearish)'};
  fill-opacity: ${props => (props.gradientId ? 1 : 0.3)};
  clip-path: ${props => props.clipPath || 'none'};
`;

export const AnimatedGroup = styled.g`
  animation: ${slideIn} 0.3s cubic-bezier(0.25, 0.5, 0.5, 1.5); ;
`;
